import React, { useContext, useState } from 'react';
import { Card, Button, Spinner, Form, Modal, Col, Row } from 'react-bootstrap';
import { useContextInfo } from '../../../context/ContextInfo';
import { AuthContext } from '../../../auth/AuthContext';
import { useForm } from '../../../hooks/useForm';
import { uploadFile } from '../../../api/fetch';
const ModDoc = ({ show, onClose, idc, callBk }) => {
    const { setResp } = useContextInfo();
    const { auth } = useContext(AuthContext);
    const [validated, setValidated] = useState(false);
    const [load, setLoad] = useState(false);

    const [pdf, setPdf] = useState(null);
    const [check, setCheck] = useState(false);

    const [values, handleInputChange, reset] = useForm({
        id: '',
        titulo: '',
        nota: '',
    });
    const { id, titulo, nota } = values;
    const funClose = () => {
        if (id) {
            onClose();
        } else {
            reset();
            onClose();
        }
    };
    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setLoad(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            let bodyContent = new FormData();
            bodyContent.append('archivo', pdf);
            bodyContent.append('id_user', idc);
            bodyContent.append('titulo', titulo);
            bodyContent.append('nota', nota);
            bodyContent.append('idagente', auth.uid);
            bodyContent.append('seecl', check);

            const res = await uploadFile(bodyContent, `uploads/docuser`, 'POST');
            setResp(res);
            callBk();
            setLoad(false);

            if (res.ok) funClose();
        }
        setLoad(false);
    };
    return (
        <Modal show={show} onHide={funClose}>
            <Modal.Header onHide={funClose} closeButton>
                <h4 className="modal-title">Nuevo Documento</h4>
            </Modal.Header>
            <Modal.Body>
                <>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Form noValidate validated={validated} onSubmit={onSubmit}>
                                        <Col>
                                            {' '}
                                            <Form.Group className="mb-2" controlId="validationCusto">
                                                <Form.Label> Seleccionar archivo</Form.Label>
                                                <Form.Control
                                                    required
                                                    type="file"
                                                    onChange={(e) => setPdf(e.target.files[0])}
                                                    id="upload"
                                                    accept="application/pdf"
                                                />
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                            </Form.Group>{' '}
                                        </Col>
                                        <Form.Group className="mb-3" controlId="validationCustom999">
                                            <Form.Label>Titulo</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                value={values.titulo}
                                                name="titulo"
                                                onChange={handleInputChange}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                        <Form.Group className="mb-3" controlId="validationCustow">
                                            <Form.Label>Descripción</Form.Label>
                                            <Form.Control
                                                as={'textarea'}
                                                type="text"
                                                value={values.nota}
                                                name="nota"
                                                onChange={handleInputChange}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                        <Form.Group className="mb-3" controlId="validationCustoe">
                                            <Form.Check
                                                type="switch"
                                                id="custom-switch"
                                                label=" Mostrar al cliente"
                                                checked={check}
                                                onChange={() => setCheck(!check)}
                                            />
                                        </Form.Group>{' '}
                                        {load ? (
                                            <Button color="primary" disabled>
                                                <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                                Guardando...
                                            </Button>
                                        ) : (
                                            <Button type="submit">Guardar</Button>
                                        )}
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            </Modal.Body>
        </Modal>
    );
};

export default ModDoc;
